/**
 * 입력 필드 검증 및 제한 관련 유틸리티 함수들
 */

/**
 * 영문과 숫자만 허용하는 키 입력 핸들러
 * @param e - 키보드 이벤트
 * @returns void
 */
export const handleAlphanumericKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  // 허용되는 특수 키들
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
    'PageUp',
    'PageDown',
  ];

  // Ctrl/Cmd + 키 조합 허용 (복사, 붙여넣기, 전체선택 등)
  if (e.ctrlKey || e.metaKey) {
    return;
  }

  // 허용되는 특수 키들
  if (allowedKeys.includes(e.key)) {
    return;
  }

  // 영문, 숫자가 아닌 경우 입력 차단
  if (!/^[a-zA-Z0-9]$/.test(e.key)) {
    e.preventDefault();
  }
};

/**
 * 영문과 숫자만 남기고 나머지 문자 제거
 * @param value - 입력값
 * @returns 필터링된 문자열
 */
export const filterAlphanumeric = (value: string): string => value.replace(/[^a-zA-Z0-9]/g, '');

/**
 * 영문과 숫자 입력만 허용하는 onChange 핸들러 생성기
 * @param onChange - 원본 onChange 함수
 * @returns 필터링이 적용된 onChange 핸들러
 */
export const createAlphanumericChangeHandler =
  (onChange: (value: string) => void) => (inputValue: string) => {
    const filteredValue = filterAlphanumeric(inputValue);
    onChange(filteredValue);
  };

/**
 * 영문과 숫자 입력 제한을 위한 통합 핸들러들을 반환
 * @param onChange - 원본 onChange 함수
 * @returns 키 다운 핸들러와 변경 핸들러 객체
 */
export const useAlphanumericInput = (onChange: (value: string) => void) => ({
  onKeyDown: handleAlphanumericKeyDown,
  onChange: createAlphanumericChangeHandler(onChange),
});
